import { useLazyQuery } from "@apollo/client";
import { GET_ORG_PATH_ID, IS_SCOPE } from "../graphql/org-gql";
import { useEffect, useState } from "react";
import useAuth from "./useAuth";

export default function useTopCoordinator(orgId: number): boolean {
  const [isTopCoordinator, setIsTopCoordinator] = useState<boolean>(false);
  const { isAdmin, isCoordinator } = useAuth();
  
  // Initialize lazy queries without variables
  const [getIsScope] = useLazyQuery(IS_SCOPE);
  const [getOrgPathId] = useLazyQuery(GET_ORG_PATH_ID);

  useEffect(() => {
    const fetchData = async () => {
      if(isAdmin) return true;
      if (!isCoordinator) return false; // Exit if the user is not a coordinator
      
      try {
        // Fetch the organization path
        console.log("orgId:",orgId)
        const orgPathResponse = await getOrgPathId({ variables: { id:orgId } });
        console.log("orgPathResponse:",orgPathResponse)
        const orgPathId = orgPathResponse.data?.orgPathId;

        if (orgPathId && orgPathId.length > 1) {
          // Fetch the scope with the second item in orgPathId
          const isScopeResponse = await getIsScope({ variables: { orgId: orgPathId[1], isLowerLevel: false } });
          console.log("isScopeResponse:",isScopeResponse)
          if (isScopeResponse.data?.isScope) {
            setIsTopCoordinator(true);
          } else {
            setIsTopCoordinator(false);
          }
        } else {
          setIsTopCoordinator(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [getIsScope, getOrgPathId, orgId, isCoordinator]); // Add missing dependencies

  return isTopCoordinator;
}
